(() => {
  const dialog = document.getElementById('desktop-launcher-dialog');
  if (!dialog) return;
  let opener;
  document.addEventListener('click', event => {
    const button = event.target.closest('#header-desktop-launcher');
    if (!button || dialog.open) return;
    opener = button;
    dialog.showModal();
    document.body.classList.add('sf-desktop-launcher-open');
    button.setAttribute('aria-expanded', 'true');
    dialog.querySelector('.launcher-close').focus({preventScroll: true});
  });
  dialog.querySelector('.launcher-close').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const box = dialog.getBoundingClientRect();
    if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
  });
  dialog.addEventListener('close', () => {
    document.body.classList.remove('sf-desktop-launcher-open');
    document.getElementById('header-desktop-launcher')?.setAttribute('aria-expanded', 'false');
    if (opener?.isConnected) opener.focus({preventScroll: true});
  });
})();
